'use client'
import { Accordion, AccordionItem, AccordionItemProps } from '@nextui-org/accordion'

import { FC } from 'react'

import { styles } from '@/app/shared/ui/accordion/constants/accordion.constants'

// interface
interface IAccordion extends AccordionItemProps {
  data?: {
    title?: string | null
    content: JSX.Element | string
  }[]
  classWrapper?: string
}

// component
const AccordionComponent: FC<Readonly<IAccordion>> = ({ data, ...props }) => {
  // return
  return (
    <Accordion>
      {data
        ? data?.map((el, index: number) => (
            <AccordionItem
              key={index}
              aria-label={'label'}
              title={el.title}
              classNames={styles}
              {...props}
            >
              {el.content}
            </AccordionItem>
          ))
        : null}
    </Accordion>
  )
}

export default AccordionComponent
